import Header from "@/components/landing/Header";
import Footer from "@/components/landing/Footer";
import PartnerHero from "@/components/landing/partner/PartnerHero";
import PartnerHowItWorks from "@/components/landing/partner/PartnerHowItWorks";
import PartnerBenefits from "@/components/landing/partner/PartnerBenefits";
import PartnerTestimonials from "@/components/landing/partner/PartnerTestimonials";
import CustomerLogosSection from "@/components/landing/CustomerLogosSection";
import CTASection from "@/components/landing/CTASection";
import { SEOHead } from "@/hooks/useSEO";
import { useLanguage } from "@/hooks/useLanguage";
import {
  StructuredDataHead,
  LLMMetadataHead,
  organizationSchema,
  createWebPageSchema,
} from "@/hooks/useStructuredData";

const PartnerProgram = () => {
  const { language } = useLanguage();

  return (
    <div className="min-h-screen bg-background">
      <SEOHead page="loesungspartner" locale={language} />
      <StructuredDataHead schemas={[
        organizationSchema,
        createWebPageSchema(
          "Lösungspartner-Programm – 20% wiederkehrende Provision | Chathero",
          "Werde Chathero Lösungspartner und verdiene 20% wiederkehrende Provision. Erweitere dein Service-Portfolio mit KI-gestützten AI Agent Lösungen.",
          "/loesungspartner-programm",
          [
            { name: "Home", url: "/" },
            { name: "Lösungspartner-Programm", url: "/loesungspartner-programm" },
          ]
        ),
      ]} />
      <LLMMetadataHead
        title="Lösungspartner-Programm – 20% wiederkehrende Provision | Chathero"
        description="Werde Chathero Lösungspartner und verdiene 20% wiederkehrende Provision. Erweitere dein Service-Portfolio mit KI-gestützten AI Agent Lösungen."
        keywords="Chathero Partner, Affiliate Programm, AI Reseller, Chatbot Partner, Agentur Partnerschaft"
        canonicalUrl="https://chathero.ai/loesungspartner-programm"
        aiCategory="Partner-Programm, Affiliate, Reseller"
        aiEntityType="Partner Program Page"
        aiUseCase="Agentur-Partnerschaft, AI Reselling, 20% wiederkehrende Provision"
      />
      <Header />
      <main>
        <PartnerHero />
        <PartnerHowItWorks />
        <PartnerBenefits />
        <CustomerLogosSection />
        <PartnerTestimonials />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default PartnerProgram;
